import React, { useState } from "react";

interface Props {
  onCreate: (orgName: string) => void;
}

const CreateOrganisationStep: React.FC<Props> = ({ onCreate }) => {
  const [orgName, setOrgName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!orgName.trim()) {
      setError("Organisation name is required");
      return;
    }
    setError("");
    onCreate(orgName.trim());
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-gray-100 mb-6">
        Create your organisation
      </h2>
      <div>
        <label
          htmlFor="orgName"
          className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
        >
          Organisation Name
        </label>
        <div className="mt-2">
          <input
            id="orgName"
            name="orgName"
            type="text"
            required
            className="block w-full rounded-md border-0 py-1.5 bg-white dark:bg-gray-600 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholder="Organisation Name"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            autoFocus
          />
        </div>
        {error && (
          <div className="text-red-500 text-sm mt-2 dark:text-red-400">
            {error}
          </div>
        )}
      </div>
      <div>
        <button
          type="submit"
          className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 dark:hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Continue
        </button>
      </div>
    </form>
  );
};

export default CreateOrganisationStep;
